import React from 'react'
import { Query } from 'react-apollo'
import {
  ApplicationArchitectureComponentType,
  EncryptionStatusType
} from './index'
import gql from 'graphql-tag'

const applicationArchitectureComponentsQuery = gql`
  query ApplicationArchitectureComponents(
    $organizationID: ID!
    $applicationID: ID!
  ) {
    applicationArchitectureComponents(
      organizationID: $organizationID
      applicationID: $applicationID
    ) {
      type
      location
      port
      vendorName
      hash
      encryptionStatus
    }
  }
`

export interface ApplicationArchitectureComponent {
  readonly type: ApplicationArchitectureComponentType
  readonly location: string
  readonly port: string
  readonly vendorName?: string
  readonly hash: string
  readonly encryptionStatus: EncryptionStatusType
}

interface ChildProps {
  readonly applicationArchitectureComponents: ApplicationArchitectureComponent[]
  readonly loading: boolean
}

interface Props {
  readonly applicationID: string
  readonly organizationID: string
  readonly children: (props: ChildProps) => React.ReactNode
}

interface VarsWithoutAgg {
  readonly organizationID: string
  readonly applicationID: string
}

type Vars = VarsWithoutAgg

// TODO flowmap - add tests CONTRAST-37856
export function ApplicationArchitectureComponentsLoader({
  applicationID,
  organizationID,
  children
}: Props) {
  const variables: Vars = Object.assign(
    {},
    {
      organizationID,
      applicationID
    }
  )

  return (
    <Query
      fetchPolicy="network-only"
      query={applicationArchitectureComponentsQuery}
      variables={variables}
      errorPolicy="all"
    >
      {(result) => {
        const { data, error, loading } = result
        if (error) {
          throw new Error(error.message)
        }

        const applicationArchitectureComponents: ApplicationArchitectureComponent[] =
          data.applicationArchitectureComponents || []

        return children({
          applicationArchitectureComponents,
          loading
        })
      }}
    </Query>
  )
}
